// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"waTA0Zmc9Nje8U1aVzRO","itemsContainer":"seiMBJO5erCC7Meo_zKD"};